import { createFileRoute } from "@tanstack/react-router";
import { PortalAttendance } from "@/components/portal/portal-attendance";
import { portalAttendanceQuery, requirePortalFeature } from "@/lib/portal-data";

export const Route = createFileRoute("/portal/attendance/")({
  beforeLoad: ({ context }) => requirePortalFeature(context.queryClient, "attendance"),
  loader: ({ context }) => context.queryClient.ensureQueryData(portalAttendanceQuery),
  component: PortalAttendance,
});
